/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaPictureIcon24Solid = forwardRef('MediaPictureIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6.5A4.5 4.5 0 0 1 6.5 2h11A4.5 4.5 0 0 1 22 6.5v11a4.5 4.5 0 0 1-4.5 4.5h-11A4.5 4.5 0 0 1 2 17.5v-11Zm7.5 1a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.131 5.033a.875.875 0 0 1 1.238 0l2.799 2.8a1 1 0 0 0 1.414-1.415l-2.8-2.8a2.875 2.875 0 0 0-4.065 0l-6.174 6.175a1 1 0 1 0 1.414 1.414l6.174-6.174Z" })));
});
